import React from 'react'

function HomeBox12() {
    return (
        <div className='homebox12' id='home-box12'>
            <div className='container homebox12-container'>
                <div className='homebox12-main'>
                    <div className='HomeBox7-top'>
                        <h1>Built for every kind of local business</h1>
                        <p>Loyalific is designed to work for a wide range of businesses</p>
                    </div>

                    <div className='homebox12-content'>
                        <div className='homebox12-content-box1'>
                            <a href="/">
                                <img src="/icon-cafes-and-coffee-shops.png" alt="cafes" />
                                <h6>Cafes & Coffee Shops</h6>
                            </a>
                        </div>
                        <div className='homebox12-content-box1'>
                            <a href="/">
                                <img src="/icon-restaurants-and-food-service.png" alt="cafes" />
                                <h6>Restaurants & Food Service</h6>
                            </a>
                        </div>
                        <div className='homebox12-content-box1'>
                            <a href="/">
                                <img src="/icon-fitness-loyalty.png" alt="cafes" />
                                <h6>Fitness & Classes</h6>
                            </a>
                        </div>
                        <div className='homebox12-content-box1'>
                            <a href="/">
                                <img src="/icon-salon.png" alt="cafes" />
                                <h6>Hair, Beauty & Personal Care</h6>
                            </a>
                        </div>
                        <div className='homebox12-content-box1'>
                            <a href="/">
                                <img src="/icon-pet-care.png" alt="cafes" />
                                <h6>Pet Care & Local Services</h6>
                            </a>
                        </div>
                    </div>

                    {/* <a href="/" className='homebox12-bottom-btn'>View all industries</a> */}

                </div>
            </div>
        </div>
    )
}

export default HomeBox12